import {
  SET_ALL_NODES,
  SET_HOVERED_NODES,
  SET_AUTHENTICATION,
  SET_ALL_EDGES,
  SET_ERROR_NODES,
  SET_API_KEY,
  SET_CURRENT_PLAN
} from "./action";
const Reducer = (state, action) => {
  switch (action.type) {
    case SET_ALL_NODES:
      return {
        ...state,
        allNodes:action.payload,
      };
      case SET_ALL_EDGES:
        return {
          ...state,
          allEdges:action.payload,
        };
      case SET_HOVERED_NODES:
        return {
          ...state,
          hoveredNode:action.payload,
        };
        case SET_ERROR_NODES:
          return {
            ...state,
            erroredNode:action.payload,
          };
        case SET_AUTHENTICATION:
          return {
            ...state,
            authenticate:action.payload,
          };
        case SET_API_KEY:
          return {
            ...state,
            api_keyValue:action.payload,
          };
          case SET_CURRENT_PLAN:
            return {
              ...state,
              currentPlan:action.payload,
            };
    default:
      return state;
  }
};
export default Reducer;
